export default __webpack_public_path__ + "static/media/IMG-20240729-WA0030.9bb7c75a.jpg";